module.exports = __webpack_public_path__ + "img/icon_reg_15.f0c6fbe1.png";